class FixedBannerSlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.fbs__track');
    this.slides = Array.from(this.track.children);
    this.prevBtn = root.querySelector('.fbs__arrow--prev');
    this.nextBtn = root.querySelector('.fbs__arrow--next');
    this.dotsWrap = root.querySelector('.fbs__dots');
    this.loop = root.dataset.loop === 'true';
    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 4000;
    this.timer = null;

    this.buildDots();
    this.bindEvents();
    this.updateActiveDot();
    if (this.autoplay) this.startAutoplay();
  }

  getVisibleCount() {
    const w = window.innerWidth;
    const styles = getComputedStyle(this.root);
    let raw;
    if (w <= 749) {
      raw = styles.getPropertyValue('--fbs-cols-mobile');
    } else if (w <= 989) {
      raw = styles.getPropertyValue('--fbs-cols-tablet');
    } else {
      raw = styles.getPropertyValue('--fbs-cols-desktop');
    }
    const count = parseInt(raw, 10);
    return count > 0 ? count : 1;
  }

  scrollToIndex(index) {
    const slide = this.slides[index];
    if (!slide) return;
    this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  getCurrentIndex() {
    const scrollLeft = this.track.scrollLeft;
    let closest = 0;
    let minDiff = Infinity;
    this.slides.forEach((slide, i) => {
      const diff = Math.abs(slide.offsetLeft - scrollLeft);
      if (diff < minDiff) {
        minDiff = diff;
        closest = i;
      }
    });
    return closest;
  }

  next() {
    const visible = this.getVisibleCount();
    let index = this.getCurrentIndex() + visible;
    if (index >= this.slides.length) {
      index = this.loop ? 0 : this.slides.length - 1;
    }
    this.scrollToIndex(index);
  }

  prev() {
    const visible = this.getVisibleCount();
    let index = this.getCurrentIndex() - visible;
    if (index < 0) {
      index = this.loop ? Math.max(0, this.slides.length - visible) : 0;
    }
    this.scrollToIndex(index);
  }

  buildDots() {
    if (!this.dotsWrap) return;
    const visible = this.getVisibleCount();
    const pageCount = Math.max(1, Math.ceil(this.slides.length / visible));
    this.dotsWrap.innerHTML = '';
    for (let i = 0; i < pageCount; i++) {
      const dot = document.createElement('button');
      dot.className = 'fbs__dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
      dot.addEventListener('click', () => this.scrollToIndex(i * visible));
      this.dotsWrap.appendChild(dot);
    }
  }

  updateActiveDot() {
    if (!this.dotsWrap) return;
    const visible = this.getVisibleCount();
    const page = Math.round(this.getCurrentIndex() / visible);
    Array.from(this.dotsWrap.children).forEach((dot, i) => {
      dot.classList.toggle('is-active', i === page);
    });
  }

  bindEvents() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.prev(); this.restartAutoplay(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.next(); this.restartAutoplay(); });

    let scrollTimeout;
    this.track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.updateActiveDot(), 100);
    });

    window.addEventListener('resize', () => this.buildDots());

    this.track.addEventListener('mouseenter', () => this.stopAutoplay());
    this.track.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => this.next(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }

  restartAutoplay() {
    if (this.autoplay) this.startAutoplay();
  }
}

function initFixedBannerSliders(container = document) {
  container.querySelectorAll('.fbs').forEach((root) => {
    if (!root.dataset.fbsInit) {
      root.dataset.fbsInit = 'true';
      new FixedBannerSlider(root);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initFixedBannerSliders());

document.addEventListener('shopify:section:load', (event) => {
  initFixedBannerSliders(event.target);
});
